var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"switch-text"},[_c('section',{ref:"dom",staticClass:"switch-text-inner",style:({
      maxHeight: _vm.showFold && _vm.fold ? _vm.maxHeight + 'px' : 'initial',
      overflow: 'hidden',
    })},[_vm._t("default")],2),(_vm.showFold)?_c('div',{class:{ 'switch-btn': true, unfold: !_vm.fold },on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.fold ? "展开更多" : "收起")),_c('svg-icon',{attrs:{"iconClass":"arrow2"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }